import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { AdminLink, AppAdminLink, FrontOfficeLink, RestoAdminLink } from '../models/Routes';
import AppAdminLayout from './AppAdminLayout';
import RestoAdminLayout from './RestoAdminLayout';
import UserLayout from './UserLayout';

const AuthorizedLayout = () => {
  return (
    <div className='auth-layout'>
      <Switch>
        <Route path={AdminLink.ROOT} component={AppAdminLayout} />
        <Route path={AppAdminLink.ROOT} component={AppAdminLayout} />
        <Route path={RestoAdminLink.ROOT} component={RestoAdminLayout} />
        <Route path={FrontOfficeLink.ROOT} component={UserLayout} />
        <Redirect to={FrontOfficeLink.DEPARTMENT_SELECT} />
      </Switch>
    </div>
  );
};

export default AuthorizedLayout;
